module.exports = __webpack_public_path__ + "static/media/Karl.fee9c798.png";